/* ==========================================================================
   FRØYA GOURMET — froya-kurvtall.js v1.1 (03.11.2026)
   Kurv-tallet i toppen + «her er kurven»-animasjon.

   FEILEN (rapportert 03.11, gjenskapt i nettleser på live 1.23):
   1. PRODUKTSIDEN: Horizons «Legg i handlekurv» sier aldri fra til vår egen
      header. Tallet ble bare rettet av froya-fjern.js sin observer, og den
      starter kun hvis kurven HADDE varer da siden ble lastet. Tom kurv → tallet
      kom aldri; ellers kom det først etter ca. 2 s. Først neste side viste
      riktig tall («må trykke på andre produkter»).
   2. /cart.js sendes uten cache-header. Safari kan da svare med forrige svar,
      så tallet henger én vare etter.
   3. Forhåndshenting (speculationrules) og tilbake-knappen (bfcache) kan vise
      en side med et gammelt tall i headeren.

   LØSNINGEN: denne fila eier tallet.
   · Shopifys standardhendelse «shopify:cart:lines-update» (produktside,
     hurtigkjøp, handlekurv-skuffen): leser totalQuantity rett fra svaret.
   · Vår egen «cart:updated» (produktkort): bekrefter med en henting som
     aldri caches (?fg=tid + cache: no-store).
   · Ved sidelasting, tilbake-knappen og når fanen blir synlig igjen:
     én stille kontroll.

   ANIMASJONEN (kun når noe LEGGES I): et lite rundt bilde av varen svever i
   en myk bue fra knappen opp til kurven, kurven lyser gult og sender ut to
   rolige ringer, og tallet spretter. Bekreftelsen henger så rett under kurven
   med en pil opp (froya-toast.js). Redusert bevegelse: ingen svev, bare lys.
   CSS: assets/froya-toast.css (seksjon «Kurv-animasjon»).

   v1.1: kontrollen ved sidelasting kjøres STRAKS (ikke når nettleseren er
   ledig), og et sent svar kan aldri overskrive et nyere tall (seq-vakt på
   alle kilder: Shopify-svar, egne hentinger og kortenes hendelser).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__fgKurvtall) return;
  window.__fgKurvtall = true;

  var mqRo = window.matchMedia('(prefers-reduced-motion: reduce)');
  var KNAPP = '.fg-card__add, .fgc__add, button[name="add"], .add-to-cart-button, .quick-add__button, [data-fg-add-form] [type="submit"]';
  var CELLE = '.fg-card, .fgc__card, product-card, .resource-card';
  var STR = 56;

  var sistKnapp = null;
  var sistKnappT = 0;
  var hentNr = 0;
  var sistHent = 0;
  var seq = 0;        /* teller for hver kurv-endring vi vet om */
  var brukt = 0;      /* seq for tallet som vises nå */

  function kurv() { return document.querySelector('.fg-header__cart'); }
  function badge() { return document.querySelector('[data-fg-cart-count]'); }

  function spill(el, klasse, ms) {
    if (!el) return;
    el.classList.remove(klasse);
    void el.offsetWidth;
    el.classList.add(klasse);
    clearTimeout(el['__fg_' + klasse]);
    el['__fg_' + klasse] = setTimeout(function () { el.classList.remove(klasse); }, ms);
  }

  function settTall(n) {
    n = Math.max(0, parseInt(n, 10) || 0);
    var k = kurv();
    if (!k) return;
    var b = badge();
    if (n > 0) {
      if (!b) {
        b = document.createElement('span');
        b.className = 'fg-header__badge';
        b.setAttribute('data-fg-cart-count', '');
        k.appendChild(b);
      }
      if (b.textContent !== String(n)) b.textContent = String(n);
    } else if (b) {
      b.remove();
    }
    k.setAttribute('aria-label', 'Handlekurv, ' + n + (n === 1 ? ' vare' : ' varer'));
  }
  window.fgSettKurvTall = settTall;

  /* Henting som aldri caches. Nyeste svar vinner (hentNr). */
  function hent() {
    var nr = ++hentNr;
    var minSeq = ++seq;
    sistHent = Date.now();
    return fetch('/cart.js?fg=' + Date.now(), {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || nr !== hentNr || minSeq < brukt) return null;
        brukt = minSeq;
        settTall(c.item_count);
        return c.item_count;
      })
      .catch(function () { return null; });
  }
  window.fgHentKurvTall = hent;

  /* --- Hvor kom varen fra? -------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var kn = t && t.closest ? t.closest(KNAPP) : null;
    if (kn) { sistKnapp = kn; sistKnappT = Date.now(); }
  }, true);

  function nyligKnapp() {
    return sistKnapp && Date.now() - sistKnappT < 12000 && document.body.contains(sistKnapp) ? sistKnapp : null;
  }

  function synligBilde(liste) {
    for (var i = 0; i < liste.length; i++) {
      var im = liste[i];
      var r = im.getBoundingClientRect();
      if (r.width > 20 && r.height > 20 && (im.currentSrc || im.src)) return im.currentSrc || im.src;
    }
    return '';
  }

  function bildeFra(knapp) {
    var celle = knapp && knapp.closest ? knapp.closest(CELLE) : null;
    if (celle) {
      var s = synligBilde(celle.querySelectorAll('img:not(.fg-card__layer)'));
      if (s) return s;
    }
    return synligBilde(document.querySelectorAll('main media-gallery img, main .product-media img'));
  }

  function tittelFra(knapp) {
    var form = knapp && knapp.closest ? knapp.closest('[data-fg-item-title]') : null;
    if (form) return form.getAttribute('data-fg-item-title') || '';
    var celle = knapp && knapp.closest ? knapp.closest(CELLE) : null;
    var el = celle ? celle.querySelector('.product-card__title, [class*="title"]') : document.querySelector('main h1');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* --- Svevet: bilde i en myk bue fra knappen til kurven --------------------- */
  function svev(fra, src, ferdig) {
    var k = kurv();
    if (!k || !fra || mqRo.matches || !k.animate || document.hidden) { ferdig(); return; }
    var a = fra.getBoundingClientRect();
    var b = k.getBoundingClientRect();
    var H = window.innerHeight;
    if (!a.width || !b.width || a.bottom < 0 || a.top > H) { ferdig(); return; }

    var x0 = a.left + a.width / 2 - STR / 2;
    var y0 = a.top + a.height / 2 - STR / 2;
    var dx = b.left + b.width / 2 - STR / 2 - x0;
    var dy = b.top + b.height / 2 - STR / 2 - y0;
    var lengde = Math.sqrt(dx * dx + dy * dy);
    var T = Math.round(Math.min(950, Math.max(600, 420 + lengde * 0.45)));

    var ytre = document.createElement('div');
    ytre.className = 'fg-svev';
    ytre.setAttribute('aria-hidden', 'true');
    ytre.style.left = Math.round(x0) + 'px';
    ytre.style.top = Math.round(y0) + 'px';
    var indre = document.createElement('div');
    indre.className = 'fg-svev__in' + (src ? '' : ' fg-svev__in--prikk');
    if (src) {
      var im = document.createElement('img');
      im.alt = '';
      im.decoding = 'async';
      im.src = src;
      indre.appendChild(im);
    }
    ytre.appendChild(indre);
    document.body.appendChild(ytre);

    var ferdigKalt = false;
    function slutt() {
      if (ferdigKalt) return;
      ferdigKalt = true;
      if (ytre.parentNode) ytre.parentNode.removeChild(ytre);
      ferdig();
    }

    try {
      /* Sidelengs tidlig (ease-out) + opp sent (ease-in) = en naturlig bue. */
      ytre.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }],
        { duration: T, easing: 'cubic-bezier(.22,.7,.3,1)', fill: 'forwards' }
      );
      var v = indre.animate([
        { transform: 'translateY(0) scale(.55)', opacity: 0, easing: 'cubic-bezier(.2,.8,.3,1)' },
        { transform: 'translateY(-18px) scale(1)', opacity: 1, offset: 0.2, easing: 'cubic-bezier(.55,0,.85,.45)' },
        { transform: 'translateY(' + dy + 'px) scale(.3)', opacity: 0.9 }
      ], { duration: T, fill: 'forwards' });
      v.onfinish = slutt;
      v.oncancel = slutt;
      setTimeout(slutt, T + 400);
    } catch (err) {
      slutt();
    }
  }

  function lyt() {
    spill(kurv(), 'fg-kurv-hei', 1500);
    spill(badge(), 'fg-badge-pop', 700);
  }

  function feire(knapp) {
    svev(knapp, knapp ? bildeFra(knapp) : '', lyt);
  }

  /* --- Våre egne produktkort (froya-collection, -anbefalinger, kurvknapp) ---- */
  document.addEventListener('cart:updated', function (e) {
    var d = e.detail || {};
    if (typeof d.itemCount === 'number' && d.fgKilde !== 'shopify') { brukt = ++seq; settTall(d.itemCount); }
    if (!d.fgStille) feire(nyligKnapp());
    /* Kortenes egen /cart.js-henting kan få et bufret svar i Safari.
       Shopify-svaret (totalQuantity) er allerede riktig og trenger ingen kontroll. */
    if (d.fgKilde !== 'shopify') hent();
  });

  /* --- Shopifys standardhendelse (produktside, hurtigkjøp, kurv-skuffen) ----- */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var ev = e.detail && e.detail.promise ? e.detail : e;
    var knapp = nyligKnapp();
    var minSeq = ++seq;
    var p = ev.promise;
    if (!p || typeof p.then !== 'function') { setTimeout(hent, 500); return; }
    p.then(function (svar) {
      var c = svar && svar.cart;
      var feil = svar && svar.detail && svar.detail.didError;
      var n = c && typeof c.totalQuantity === 'number' ? c.totalQuantity : null;
      if (n === null || feil) { hent(); return; }
      var nyest = minSeq >= brukt;
      if (nyest) { brukt = minSeq; settTall(n); }
      if (ev.action === 'add') {
        /* Headerens egen lytter setter også tallet fra itemCount: send aldri et eldre tall. */
        var b = badge();
        var vis = nyest ? n : (b ? parseInt(b.textContent, 10) || n : n);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { itemCount: vis, itemTitle: tittelFra(knapp), fgKilde: 'shopify' }
        }));
      }
    }, function () { hent(); });
  }, true);

  /* Horizons egne kurv-hendelser (antallsvelger i skuffen/kurvsiden): bare tall. */
  document.addEventListener('cart:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (r && typeof r.item_count === 'number') { brukt = ++seq; settTall(r.item_count); }
    else setTimeout(hent, 300);
  });

  /* --- Stille kontroll: sidelasting, tilbake-knapp, fanen synlig igjen ------- */
  function stilleKontroll() {
    if (Date.now() - sistHent < 2000) return;
    hent();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) hent(); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) stilleKontroll();
  });
  /* Straks: skriptet er «defer», så DOM-en er klar. */
  hent();
})();
